/* eslint-disable import/prefer-default-export */
export const scrollToTopOrError = (erroringFieldIds = []) => {
  if (erroringFieldIds.length === 0) {
    window.scrollTo({ top: -20, behavior: 'smooth' });
    return;
  }

  const erroringFieldIdSelectors = erroringFieldIds.map((id) => `#${id}`);
  const errorElement = document.querySelector(erroringFieldIdSelectors.join(','));
  if (errorElement) {
    window.scrollTo({
      // scroll to element with enough top padding to see label (most of the time)
      top: errorElement.getBoundingClientRect().top + window.scrollY - 200,
      behavior: 'smooth',
    });
  }
};

export const scrollToElement = (element, offset = 200) => {
  window.scrollTo({
    top: element.getBoundingClientRect().top + window.scrollY - offset,
    behavior: 'smooth',
  });
};
